import { useContext, useEffect, useState } from "react";
import { Form, Tab, Tabs } from "react-bootstrap";
import SearchBox from "../../../../../component/global/SearchBox";
import User from "./User";
import AllGroups from "./AllGroups";
import { get, post, put } from "../../../../../controlers/global/ConfigRequest";
import {
    ADD_NEW_GROUP,
    COMPANY_CLUB_GROUPS,
    COMPANY_CLUBS,
    EDIT_GROUP_CLUB,
} from "../../../../../helperData/ApiAddress";
import { ToastContext } from "../../../../../component/global/ToastContext";
import PaginationComponent from "../../../../../component/global/PaginationComponent";
import DatePickerModal from "../../../../../component/global/DatePicker";
import { ReactComponent as SearchIC } from "../../../../../asset/icons/search_ic_gr.svg";
import { GlobalStateContext } from "../../../../../layouts/GlobalStates";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

export default function AddGroup() {
    const [activeTab, setActiveTab] = useState("1");
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [groupLoading, setGroupLoading] = useState(true);
    const [groups, setGroups] = useState([]);
    const [groupMembers, setGroupMembers] = useState();
    const [pages, setPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(0);
    const [groupId, setGroupId] = useState();
    const [refresh, setRefresh] = useState(false);
    const [spLoader, setSpLoader] = useState(false);

    //filter
    const [gender, setGender] = useState(0);
    const [education, setEducation] = useState(0);
    const [place, setPlace] = useState("");
    const [birthDate, setBirthDate] = useState({
        fa: "1400-01-01",
        en: "2021-01-01",
    });
    const [birthDatePicker, setBirthDatePicker] = useState(false);

    const [groupName, setGroupName] = useState("");
    const [groupError, setGroupError] = useState("");

    const [membersGroup, setMembersGroup] = useState([]);
    const [membersGroupErr, setMembersGroupErr] = useState([]);

    const [editMode, setEditMode] = useState(false);

    const { auth, setAuth } = useContext(GlobalStateContext);
    const show = useContext(ToastContext);
    const { t } = useTranslation();

    const handleError = () => {
        let groupErrorMessage = "";
        let membersGroupErrMessage = "";

        if (groupName === "") {
            groupErrorMessage = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddGroup.groupErrorMessage"
            );
        }

        if (membersGroup.length < 2) {
            membersGroupErrMessage = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddGroup.membersGroupErrMessage"
            );
        }

        setGroupError(groupErrorMessage);
        setMembersGroupErr(membersGroupErrMessage);

        if (groupErrorMessage === "" && membersGroupErrMessage === "") {
            return true;
        }

        return false;
    };

    const handleEditGroup = (id, name) => {
        setGroupName(name);
        fetchSingleGroup(id);
        setGroupId(id);
    };

    const fetchCompanyGroups = ({ pageIndex }) => {
        setLoading(true);
        get(COMPANY_CLUB_GROUPS).then((r) => {
            setGroups(r.results);
            setLoading(false);
        });
    };

    useEffect(() => {
        if (activeTab === "1") {
            fetchCustomerCards({ pageIndex: 1 });
        }
        if (activeTab === "2") {
            fetchCompanyGroups({ pageIndex: 1 });
        }
    }, [activeTab]);

    const fetchSingleGroup = (id) => {
        setGroupLoading(true);
        console.log(groups?.filter((item) => item.id === id));
        const newItem = groups
            ?.filter((item) => item.id === id)
            .map((t) => t.members);
        setGroupMembers(newItem[0]);
        const prevGroup = newItem[0].map((item) => {
            return { company_club: item.company_club };
        });
        setMembersGroup(prevGroup);
        setGroupLoading(false);
    };

    const fetchCustomerCards = ({ pageIndex }) => {
        setLoading(true);
        get(COMPANY_CLUBS.replace("{id}/", pageIndex + 1)).then((r) => {
            setMembers(r.results);
            setLoading(false);
            setPages(Math.ceil(r.count / 20));
        });
    };

    const filteredCustomerCards = ({ pageIndex }) => {
        setLoading(true);
        get(COMPANY_CLUBS.replace("{id}/", pageIndex + 1), {
            sex: gender,
            education,
            birthday_from: birthDate.en,
        }).then((r) => {
            setMembers(r.results);
            setLoading(false);
            setPages(Math.ceil(r.count / 20));
        });
    };

    const sendCustomersGroup = (e) => {
        e.preventDefault(e);

        const noErr = handleError();

        if (noErr) {
            setSpLoader(true);
            post(ADD_NEW_GROUP, {
                name: groupName,
                company: auth.usercompany,
                members: membersGroup,
            })
                .then((r) => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddGroup.success"
                        ),
                        "success"
                    );
                    const newMemberArr = membersGroup?.splice(
                        0,
                        membersGroup.length
                    );
                    setMembersGroup(newMemberArr);
                    const newGroupArr = groupMembers?.splice(
                        0,
                        groupMembers.length
                    );
                    setGroupMembers(newGroupArr);
                    setGroupName("");
                    setRefresh(!refresh);
                    setActiveTab("2");
                    setSpLoader(false);
                })
                .catch(() => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddGroup.Danger"
                        ),
                        "danger"
                    );
                    setSpLoader(false);
                });
        }

        const newMemberArr = membersGroup?.splice(0, membersGroup.length);
        setMembersGroup(newMemberArr);
        const newGroupArr = groupMembers?.splice(0, groupMembers.length);
        setGroupMembers(newGroupArr);
    };

    const sendEditedGroup = () => {
        const noErr = handleError();

        if (noErr) {
            setSpLoader(true);
            put(EDIT_GROUP_CLUB.replace("{id}", groupId), {
                name: groupName,
                company: auth.usercompany * 1,
                members: membersGroup,
            })
                .then(() => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddGroup.Edit.success"
                        ),
                        "success"
                    );
                    setRefresh(!refresh);
                    setGroupName("");
                    setEditMode(false);
                    setActiveTab("2");
                    const newGroupArr = groupMembers?.splice(
                        0,
                        groupMembers.length
                    );
                    setGroupMembers(newGroupArr);
                    setSpLoader(false);
                })
                .catch(() => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddGroup.Danger"
                        ),
                        "danger"
                    );
                    setSpLoader(false);
                });
        }

        const newMemberArr = membersGroup?.splice(0, membersGroup.length);
        setMembersGroup(newMemberArr);
        const newGroupArr = groupMembers?.splice(0, groupMembers.length);
        setGroupMembers(newGroupArr);
    };

    useEffect(() => {
        fetchCustomerCards({ pageIndex: currentPage });
        fetchCompanyGroups({ pageIndex: currentPage });
        const newArr = membersGroup?.splice(0, membersGroup.length);
        setMembersGroup(newArr);
    }, []);

    useEffect(() => {
        fetchCompanyGroups({ pageIndex: currentPage });
        fetchCustomerCards({ pageIndex: currentPage });
        const newArr = membersGroup?.splice(0, membersGroup.length);
        setMembersGroup(newArr);
    }, [refresh]);

    return (
        <div className="add-groups-container">
            <div>
                <Tabs
                    activeKey={activeTab}
                    transition={false}
                    className="panel_tab sub-tabs"
                    onSelect={(e) => setActiveTab(e)}
                >
                    <Tab
                        eventKey="1"
                        className="panel_tab_item"
                        title={
                            editMode
                                ? t(
                                      "Organizational.CustomerClub.NewGroup.Edit.Tab"
                                  )
                                : t("Organizational.CustomerClub.NewGroup.Tab")
                        }
                        onSelect={() => console.log("test123456")}
                    >
                        {activeTab === "1" && (
                            <>
                                <div className="new-user-form">
                                    <Form.Group controlId="formGroupName">
                                        <Form.Label>
                                            {t(
                                                "Organizational.CustomerClub.GroupName.Place.Holder"
                                            )}
                                        </Form.Label>
                                        <Form.Control
                                            value={groupName}
                                            onChange={(e) =>
                                                setGroupName(e.target.value)
                                            }
                                            type="text"
                                            placeholder="مثال : نیما"
                                        />
                                        <div
                                            className="error"
                                            style={{
                                                display:
                                                    groupError ||
                                                    membersGroupErr
                                                        ? "block"
                                                        : "none",
                                            }}
                                        >
                                            {groupError || membersGroupErr}
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="group-search">
                                    <SearchBox />
                                    <div className="filter-container">
                                        <select
                                            value={gender}
                                            name="gender"
                                            id="gender"
                                            onChange={(e) =>
                                                setGender(e.target.value)
                                            }
                                        >
                                            <option disabled selected>
                                                {t(
                                                    "Organizational.CustomerClub.Gender.Drop.Filter"
                                                )}
                                            </option>
                                            <option value={1}>
                                                {t(
                                                    "Organizational.CustomerClub.GenderMale.Drop.Filter"
                                                )}
                                            </option>
                                            <option value={2}>
                                                {t(
                                                    "Organizational.CustomerClub.GenderFemale.Drop.Filter"
                                                )}
                                            </option>
                                        </select>

                                        <div className="filter-date-container">
                                            <Form.Group controlId="formBasicBday">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="مثال : نیما"
                                                    className="input-date"
                                                    onChange={(e) =>
                                                        setBirthDate(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={birthDate.fa}
                                                    onClick={(e) =>
                                                        setBirthDatePicker(true)
                                                    }
                                                />
                                            </Form.Group>
                                            {birthDatePicker && (
                                                <DatePickerModal
                                                    show={birthDatePicker}
                                                    close={setBirthDatePicker}
                                                    defaultValue={birthDate.fa}
                                                    onChange={setBirthDate}
                                                />
                                            )}
                                        </div>
                                        <select
                                            value={education}
                                            name="education"
                                            id="education"
                                            onChange={(e) =>
                                                setEducation(e.target.value)
                                            }
                                        >
                                            <option disabled selected>
                                                {t(
                                                    "Organizational.CustomerClub.Degree.Disable.Filter"
                                                )}
                                            </option>
                                            <option value={1}>
                                                {t(
                                                    "Organizational.CustomerClub.Degree.Diploma.Drop.Filter"
                                                )}
                                            </option>
                                            <option value={2}>
                                                {t(
                                                    "Organizational.CustomerClub.Degree.Bachelor's.Drop.Filter"
                                                )}
                                            </option>
                                            <option value={3}>
                                                {t(
                                                    "Organizational.CustomerClub.Degree.Master's.Drop.Filter"
                                                )}
                                            </option>
                                            <option value={4}>
                                                {t(
                                                    "Organizational.CustomerClub.Degree.PhD.Drop.Filter"
                                                )}
                                            </option>
                                        </select>

                                        <button
                                            className="search-button"
                                            onClick={() =>
                                                filteredCustomerCards({
                                                    pageIndex: currentPage,
                                                })
                                            }
                                        >
                                            <SearchIC />
                                        </button>
                                    </div>
                                </div>
                                <div className="table">
                                    <div className="user-grid">
                                        {groupLoading === false ? (
                                            groupMembers.map((data, index) => {
                                                return (
                                                    <User
                                                        data={data}
                                                        key={index}
                                                        setMembersGroup={
                                                            setMembersGroup
                                                        }
                                                        membersGroup={
                                                            membersGroup
                                                        }
                                                        active={true}
                                                    />
                                                );
                                            })
                                        ) : editMode ? (
                                            <Spinner
                                                animation="border"
                                                role="status"
                                            >
                                                <span className="visually-hidden">
                                                    Loading...
                                                </span>
                                            </Spinner>
                                        ) : (
                                            ""
                                        )}
                                        {loading === false ? (
                                            members.length > 0 ? (
                                                editMode ? (
                                                    members
                                                        .filter(
                                                            (item) =>
                                                                !groupMembers
                                                                    ?.map(
                                                                        (
                                                                            item
                                                                        ) =>
                                                                            item?.company_club
                                                                    )
                                                                    .includes(
                                                                        item.id
                                                                    )
                                                        )
                                                        .map((data, index) => {
                                                            return (
                                                                <User
                                                                    data={data}
                                                                    key={index}
                                                                    setMembersGroup={
                                                                        setMembersGroup
                                                                    }
                                                                    membersGroup={
                                                                        membersGroup
                                                                    }
                                                                    groupMembers={
                                                                        groupMembers
                                                                    }
                                                                    active={
                                                                        false
                                                                    }
                                                                />
                                                            );
                                                        })
                                                ) : (
                                                    members.map(
                                                        (data, index) => {
                                                            return (
                                                                <User
                                                                    data={data}
                                                                    key={index}
                                                                    setMembersGroup={
                                                                        setMembersGroup
                                                                    }
                                                                    membersGroup={
                                                                        membersGroup
                                                                    }
                                                                    active={
                                                                        false
                                                                    }
                                                                />
                                                            );
                                                        }
                                                    )
                                                )
                                            ) : (
                                                <div>
                                                    {t(
                                                        "Organizational.CustomerClub.Not.Found.Title"
                                                    )}
                                                </div>
                                            )
                                        ) : (
                                            <Spinner
                                                animation="border"
                                                role="status"
                                            >
                                                <span className="visually-hidden"></span>
                                            </Spinner>
                                        )}
                                    </div>
                                </div>
                                <div className="pagination">
                                    <PaginationComponent
                                        pageCount={pages}
                                        key={currentPage}
                                        fetchData={fetchCustomerCards}
                                        currentPage={currentPage}
                                        setCurrentPage={(e) =>
                                            setCurrentPage(e)
                                        }
                                        feedbacks={4}
                                    />
                                </div>
                                <div className="btn-row">
                                    <div className="btn-group">
                                        <button
                                            onClick={
                                                editMode
                                                    ? sendEditedGroup
                                                    : sendCustomersGroup
                                            }
                                            className="send-bt-style blue"
                                        >
                                            {spLoader && (
                                                <Spinner
                                                    animation="border"
                                                    role="status"
                                                    size="sm"
                                                >
                                                    <span className="visually-hidden"></span>
                                                </Spinner>
                                            )}
                                            {editMode
                                                ? t(
                                                      "Organizational.CustomerClub.MakeGroup.Button.Edit"
                                                  )
                                                : t(
                                                      "Organizational.CustomerClub.MakeGroup.Button"
                                                  )}
                                        </button>
                                        <button
                                            className=" red"
                                            onClick={() => {
                                                setEditMode(false);
                                                setActiveTab("2");
                                                setGroupName("");
                                                setGroupMembers([]);
                                                setMembersGroup([]);
                                            }}
                                        >
                                            {t(
                                                "Organizational.CustomerClub.MakeGroup.Button.Cancel"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </Tab>
                    <Tab
                        eventKey="2"
                        className="panel_tab_item"
                        title={t("Organizational.CustomerClub.Groups")}
                    >
                        {activeTab == 2 && (
                            <>
                                <div className="table group-table">
                                    {loading === false ? (
                                        groups.map((data, index) => {
                                            return (
                                                <AllGroups
                                                    key={index}
                                                    data={data}
                                                    handleEditGroup={
                                                        handleEditGroup
                                                    }
                                                    setActiveTab={setActiveTab}
                                                    setEditMode={setEditMode}
                                                    setRefresh={setRefresh}
                                                />
                                            );
                                        })
                                    ) : (
                                        <div
                                            style={{
                                                direction: "rtl",
                                                textAlign: "center",
                                                marginTop: 20,
                                            }}
                                        >
                                            {t(
                                                "Src.Layouts.AppContent.MainPleaseWait"
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </Tab>
                </Tabs>
            </div>
        </div>
    );
}
